export default {
	careers(state) {
		return state.careers
	},
}
